import { useEffect, useLayoutEffect } from "react";
import { isSafari } from "react-device-detect";
import confetti from "../../Assets/images/confetti.svg";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { useHeader } from "../../Providers/HeaderContextProvider";
function NewConfirmation() {
  const navigate = useNavigate();
  const { setHeaderContent, setHeaderContentRightSideContent } = useHeader();

  useLayoutEffect(() => {
    setHeaderContent(true);
    setHeaderContentRightSideContent(true);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      navigate("/dashboard");
    }, 3000);
  }, []);

  return (
    <div className="img-cnt">
      <img src={confetti} alt="pop" className="confetti" />
        <div className="onboarding-container">
          <div className="onboarding-content">
            <video className="responsive-video" autoPlay loop muted>
              <source
                src={
                  isSafari
                    ? `${process.env.REACT_APP_STATIC_CONTENT}ui-components/sphere-ios.mov`
                    : `${process.env.REACT_APP_STATIC_CONTENT}ui-components/Sphere_Loader.webm`
                }
                type="video/webm"
              />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
    </div>
  );
}

export default NewConfirmation;
